import { useRouterState } from "@tanstack/react-router";

/**
 * Thin progress bar shown at the top of the viewport during route transitions.
 * Renders nothing when the router is idle.
 */
export function RouteProgress() {
  const isLoading = useRouterState({ select: (s) => s.isLoading });

  if (!isLoading) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden bg-primary/20">
      <div className="h-full w-1/3 animate-progress-bar bg-primary" />
    </div>
  );
}
